module.exports = __webpack_public_path__ + "static/5-b00b854fe8e9b375be9e977e96921b3e.png";